import { extendTheme } from '@chakra-ui/core';
import 'typeface-roboto';
import components from './components';

export default extendTheme({
  styles: {
    global: {
      'html, body': {
        fontFamily: "'Roboto', 'Arial', sans-serif;",
      },
    },
  },
  components,
  colors: {
    blue: {
      100: '#32325d',
      200: '#32325d',
      300: '#32325d',
      400: '#42486b',
      500: '#6772e5',
      600: '#606eff',
    },
  },
});
